// DocumentActions.jsx
import React from 'react';

const DocumentActions = ({ 
  status, 
  aiEnabled, 
  onSaveDraft, 
  onSignComplete, 
  onVoiceDictation, 
  onToggleAI,
  noteContent 
}) => {
  // Generate AI suggestions based on the content of the note
  const generateSuggestions = () => {
    // In a real app, these would be generated by an AI based on the note content
    let suggestions = [];
    
    if (!noteContent.chiefComplaint || noteContent.chiefComplaint.length < 5) {
      suggestions.push("Add chief complaint");
    }
    
    if (noteContent.assessment && noteContent.assessment.includes("breast cancer")) {
      suggestions.push("Family history details");
      suggestions.push("Genetic testing plans");
      suggestions.push("Staging workup");
    }
    
    if (noteContent.medicalHistory && noteContent.medicalHistory.includes("Mother with breast cancer")) {
      suggestions.push("Consider genetic counseling referral");
    }
    
    return suggestions.length > 0 ? suggestions : ["Note appears complete"];
  };

  const aiSuggestions = aiEnabled ? generateSuggestions() : [];

  return (
    <div className="bg-gray-200 p-4 h-full">
      <h2 className="text-lg font-medium text-gray-700 mb-4">Document Actions:</h2>
     
      <div className="space-y-3">
        <button 
          className="w-full py-2 bg-green-500 text-white rounded hover:bg-green-600"
          onClick={onSaveDraft}
        >
          Save Draft
        </button>
       
        <button 
          className="w-full py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          onClick={onSignComplete}
        >
          Sign & Complete
        </button>
       
        <button 
          className="w-full py-2 bg-purple-500 text-white rounded hover:bg-purple-600"
          onClick={onVoiceDictation}
        >
          Voice Dictation
        </button>
       
        <button 
          className={`w-full py-2 ${aiEnabled ? 'bg-red-500' : 'bg-gray-500'} text-white rounded hover:bg-red-600`}
          onClick={onToggleAI}
        >
          {aiEnabled ? 'Disable' : 'Enable'} AI Suggestions
        </button>
      </div>
     
      {aiEnabled && (
        <div className="mt-8">
          <h3 className="font-medium text-gray-700 mb-2">AI Suggestions:</h3>
          <div className="bg-white p-3 rounded shadow">
            <p className="text-gray-600 text-sm mb-2">Based on your entry, consider adding:</p>
            <ul className="space-y-1 text-sm">
              {aiSuggestions.map((suggestion, index) => (
                <li key={index} className="text-gray-700 flex items-start">
                  <span className="mr-1">•</span> {suggestion}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentActions;